import React, { useEffect, useState } from 'react';
import as from '../../asserts/as.png';
import './preloader.css';

const Preloader = () => {
    const [visible, setVisible] = useState(true);
    const [hide, setHide] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setHide(true);
            setTimeout(() => {
                setVisible(false);
            }, 700);
        }, 4000);

        return () => clearTimeout(timer);
    }, []);

    if (!visible) return null;

    return (
        <div 
            className={`loader ${hide ? 'loader--hide' : ''}`} 
            role="status" 
            aria-live="polite" 
            aria-busy={!hide}
        >
            <div className="loader__scene" aria-hidden="true">
                <div className="loader__square loader__square--outer"></div>
                <div className="loader__square loader__square--middle"></div>
                <img className="loader__square loader__square--inner" src={as} alt="" />
            </div>
            <p className="loader__text">LOADING</p>
            <span className="sr-only">Loading, please wait...</span>
        </div>
    );
};

export default Preloader;